<template>
	<v-app>
		<div class="loader" v-if="$myStore.state.loaderCount > 0">
			<v-progress-circular
				:size="50"
				color="primary"
				indeterminate
			></v-progress-circular>
		</div>

		<v-dialog max-width="480" v-model="alertModal.show">
			<v-card>
				<v-card-title></v-card-title>
				<v-card-text class="grey--text text--darken-2" v-html="alertModal.text">
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="alertModal.show = false" depressed color="success">{{ $t('buttons.ok') }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog max-width="480" persistent v-model="verifyModal.show">
			<v-card class="pa-4">
				<v-card-text class="grey--text text--darken-2" v-html="verifyModal.text">
				</v-card-text>
				<v-card-actions>
					<v-btn @click="verifyModal.result(false)" color="error" depressed>{{ $t('buttons.no') }}
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn @click="verifyModal.result(true)"  color="success" depressed>{{ $t('buttons.yes') }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog max-width="480" persistent v-model="promptModal.show">
			<v-card class="pa-4">
				<v-card-text class="grey--text text--darken-2">
					<InputField :label="promptModal.text"
								v-model="promptModal.value"></InputField>
				</v-card-text>
				<v-card-actions>
					<v-btn @click="promptModal.result(false)" color="error" depressed>{{ $t('buttons.cancel') }}
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn @click="promptModal.result(true)" color="success" depressed>{{ $t('buttons.ok') }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-snackbar :timeout="3000" :top="true" class="notification black--text text-center" color="primary"
					v-model="notification.show">{{ notification.text }}
		</v-snackbar>

		<template v-if="$myStore.state.loggedIn">
			<v-app-bar app clipped-left dark dense flat>
				<v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
				<v-toolbar-title>{{ $getSettings('APP_NAME') }}</v-toolbar-title>
				<v-breadcrumbs :items="$myStore.state.breadcrumbs" divider=">"></v-breadcrumbs>
				<v-spacer></v-spacer>
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn @click="logoutClick" depressed icon v-bind="attrs" v-on="on">
							<v-icon small>fa-sign-out-alt</v-icon>
						</v-btn>
					</template>
					<span>{{ $t('tooltips.logout') }}</span>
				</v-tooltip>
			</v-app-bar>
			<v-navigation-drawer app clipped dark v-model="drawer">
				<v-list dense>
					<v-list-item :to="{path: '/dashboard'}">
						<v-list-item-icon>
							<v-icon>fa-chart-bar</v-icon>
						</v-list-item-icon>
						<v-list-item-title>{{ $t('modules.reports') }}</v-list-item-title>
					</v-list-item>
					<v-divider></v-divider>
					<v-list-item v-if="$myStore.state.user.user_role_id == 1" :to="{path: '/buildings'} ">
						<v-list-item-icon>
							<v-icon>fa-building</v-icon>
						</v-list-item-icon>
						<v-list-item-title>{{ $t('modules.buildings') }}</v-list-item-title>
					</v-list-item>
					<v-list-item v-if="$myStore.state.user.user_role_id == 1" :to="{path: '/user-accounts'}">
						<v-list-item-icon>
							<v-icon>fa-users</v-icon>
						</v-list-item-icon>
						<v-list-item-title>{{ $t('modules.userAccounts') }}</v-list-item-title>
					</v-list-item>
					<v-divider v-if="$myStore.state.user.user_role_id == 1"></v-divider>
					<v-list-item :to="{path: '/profile'}">
						<v-list-item-icon>
							<v-icon>fa-user-tie</v-icon>
						</v-list-item-icon>
						<v-list-item-title>{{ $t('modules.profile') }}</v-list-item-title>
					</v-list-item>
				</v-list>
			</v-navigation-drawer>
			<v-footer
				app
				dark
				fixed
				max-height="48"
				padless
			>
				<v-col
					class="text-center"
					cols="12"
					v-html="$getSettings('FOOTER_HTML')"
				>
				</v-col>
			</v-footer>
		</template>
		<v-main v-if="initialLoadCompleted">
			<transition name="fade">
				<router-view></router-view>
			</transition>
		</v-main>
	</v-app>
</template>

<script>
import InputField from "./components/trinkets/InputField"

export default {
	name: 'App',
	components: {InputField},
	data() {
		return {
			drawer: null,
			alertModal: {
				show: false,
				text: ''
			},
			verifyModal: {
				show: false,
				text: '',
				result: (result) => {
					this.verifyModal.show = false;
					this.verifyModal.reaction(result);
				},
				reaction: () => {
				}
			},
			promptModal: {
				show: false,
				text: '',
				value: '',
				result: (result) => {
					this.promptModal.show = false;
					if (result !== false) {
						this.promptModal.reaction(this.promptModal.value);
					} else {
						this.promptModal.reaction(false);
					}
				},
				reaction: () => {
				}
			},
			notification: {
				show: false,
				text: ''
			},
			initialLoadCompleted: false,
			breadcrumbs: []
		}
	},
	computed: {},
	methods: {
		logoutClick() {
			let vm = this;
			this.$APICall('post', 'logout', {}, (data, success) => {
				if (success) {
					vm.$myStore.commit('setUser', null);
					vm.$myStore.commit('setLoggedIn', false);
					vm.$router.push('/login');
				}
			});
		},
		profileClick() {
			this.$router.push('/profile');
		},
		logoClick() {
			this.$router.push('/dashboard');
		},
		showPDF(fileName) {
			window.open(process.env.BASE_URL + fileName + '.pdf');
		}
	},
	mounted() {
		var vm = this;
		this.$modalBus.$on('ALERT', message => {
			vm.alertModal.text = message;
			vm.alertModal.show = true;
		});
		this.$modalBus.$on('VERIFY', data => {
			vm.verifyModal.text = data.message;
			vm.verifyModal.reaction = data.response;
			vm.verifyModal.show = true;
		});
		this.$modalBus.$on('PROMPT', data => {
			vm.promptModal.text = data.message;
			vm.promptModal.value = data.initial;
			vm.promptModal.reaction = data.response;
			vm.promptModal.show = true;
		});
		this.$modalBus.$on('NOTIFY', message => {
			vm.notification.text = message;
			vm.notification.show = true;
		});

		this.$APICall('get', 'session', {}, (data, success) => {
			if (success) {
				vm.$myStore.commit('setUser', data);
				vm.$myStore.commit('setLoggedIn', true);
				let baseRoutes = ['login', null];
				if (baseRoutes.indexOf(vm.$router.currentRoute.name) !== -1) {
					vm.$router.push('dashboard');
				}
				vm.initialLoadCompleted = true;
				if (data.version != vm.$getCookie('m42_version')) {
					vm.$setCookie('m42_version', data.version);
					window.location.reload(true);
				}
			} else {
				vm.$APICall('get', 'version', {}, (data, success) => {
					if (success) {
						if (data.version != vm.$getCookie('m42_version')) {
							vm.$setCookie('m42_version', data.version);
							window.location.reload(true);
						}
						vm.$myStore.commit('setUser', null);
						vm.$myStore.commit('setLoggedIn', false);
						vm.$router.replace('/login');
						vm.initialLoadCompleted = true;
					}
				});
			}
		});
	}
}
</script>

<style scoped>
.notification {
	z-index: 999999;
}

.loader {
	position: fixed;
	left: 0px;
	top: 0px;
	z-index: 999;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.3);
	font-size: 100px;
	text-align: center;
	padding-top: 100px;
}


.fade-enter {
	opacity: 0;
}

.fade-enter-active {
	transition: opacity 1s;
}

.fade-to {
	opacity: 1;
}

>>> .cursor-pointer {
	cursor: pointer;
}

>>> .v-main {
	background-color: #ffffff;
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25'%3E%3Cdefs%3E%3ClinearGradient id='a' gradientUnits='userSpaceOnUse' x1='0' x2='0' y1='0' y2='100%25' gradientTransform='rotate(240)'%3E%3Cstop offset='0' stop-color='%23ffffff'/%3E%3Cstop offset='1' stop-color='%23c7c7c7'/%3E%3C/linearGradient%3E%3Cpattern patternUnits='userSpaceOnUse' id='b' width='540' height='450' x='0' y='0' viewBox='0 0 1080 900'%3E%3Cg fill-opacity='0.06'%3E%3Cpolygon fill='%23444' points='90 150 0 300 180 300'/%3E%3Cpolygon points='90 150 180 0 0 0'/%3E%3Cpolygon fill='%23AAA' points='270 150 360 0 180 0'/%3E%3Cpolygon fill='%23DDD' points='450 150 360 300 540 300'/%3E%3Cpolygon fill='%23999' points='450 150 540 0 360 0'/%3E%3Cpolygon points='630 150 540 300 720 300'/%3E%3Cpolygon fill='%23DDD' points='630 150 720 0 540 0'/%3E%3Cpolygon fill='%23444' points='810 150 720 300 900 300'/%3E%3Cpolygon fill='%23FFF' points='810 150 900 0 720 0'/%3E%3Cpolygon fill='%23DDD' points='990 150 900 300 1080 300'/%3E%3Cpolygon fill='%23444' points='990 150 1080 0 900 0'/%3E%3Cpolygon fill='%23DDD' points='90 450 0 600 180 600'/%3E%3Cpolygon points='90 450 180 300 0 300'/%3E%3Cpolygon fill='%23666' points='270 450 180 600 360 600'/%3E%3Cpolygon fill='%23AAA' points='270 450 360 300 180 300'/%3E%3Cpolygon fill='%23DDD' points='450 450 360 600 540 600'/%3E%3Cpolygon fill='%23999' points='450 450 540 300 360 300'/%3E%3Cpolygon fill='%23999' points='630 450 540 600 720 600'/%3E%3Cpolygon fill='%23FFF' points='630 450 720 300 540 300'/%3E%3Cpolygon points='810 450 720 600 900 600'/%3E%3Cpolygon fill='%23DDD' points='810 450 900 300 720 300'/%3E%3Cpolygon fill='%23AAA' points='990 450 900 600 1080 600'/%3E%3Cpolygon fill='%23444' points='990 450 1080 300 900 300'/%3E%3Cpolygon fill='%23222' points='90 750 0 900 180 900'/%3E%3Cpolygon points='270 750 180 900 360 900'/%3E%3Cpolygon fill='%23DDD' points='270 750 360 600 180 600'/%3E%3Cpolygon points='450 750 540 600 360 600'/%3E%3Cpolygon points='630 750 540 900 720 900'/%3E%3Cpolygon fill='%23444' points='630 750 720 600 540 600'/%3E%3Cpolygon fill='%23AAA' points='810 750 720 900 900 900'/%3E%3Cpolygon fill='%23666' points='810 750 900 600 720 600'/%3E%3Cpolygon fill='%23999' points='990 750 900 900 1080 900'/%3E%3Cpolygon fill='%23999' points='180 0 90 150 270 150'/%3E%3Cpolygon fill='%23444' points='360 0 270 150 450 150'/%3E%3Cpolygon fill='%23FFF' points='540 0 450 150 630 150'/%3E%3Cpolygon points='900 0 810 150 990 150'/%3E%3Cpolygon fill='%23222' points='0 300 -90 450 90 450'/%3E%3Cpolygon fill='%23FFF' points='0 300 90 150 -90 150'/%3E%3Cpolygon fill='%23FFF' points='180 300 90 450 270 450'/%3E%3Cpolygon fill='%23666' points='180 300 270 150 90 150'/%3E%3Cpolygon fill='%23222' points='360 300 270 450 450 450'/%3E%3Cpolygon fill='%23FFF' points='360 300 450 150 270 150'/%3E%3Cpolygon fill='%23444' points='540 300 450 450 630 450'/%3E%3Cpolygon fill='%23222' points='540 300 630 150 450 150'/%3E%3Cpolygon fill='%23AAA' points='720 300 630 450 810 450'/%3E%3Cpolygon fill='%23666' points='720 300 810 150 630 150'/%3E%3Cpolygon fill='%23FFF' points='900 300 810 450 990 450'/%3E%3Cpolygon fill='%23999' points='900 300 990 150 810 150'/%3E%3Cpolygon points='0 600 -90 750 90 750'/%3E%3Cpolygon fill='%23666' points='0 600 90 450 -90 450'/%3E%3Cpolygon fill='%23AAA' points='180 600 90 750 270 750'/%3E%3Cpolygon fill='%23444' points='180 600 270 450 90 450'/%3E%3Cpolygon fill='%23444' points='360 600 270 750 450 750'/%3E%3Cpolygon fill='%23999' points='360 600 450 450 270 450'/%3E%3Cpolygon fill='%23666' points='540 600 630 450 450 450'/%3E%3Cpolygon fill='%23222' points='720 600 630 750 810 750'/%3E%3Cpolygon fill='%23FFF' points='900 600 810 750 990 750'/%3E%3Cpolygon fill='%23222' points='900 600 990 450 810 450'/%3E%3Cpolygon fill='%23DDD' points='0 900 90 750 -90 750'/%3E%3Cpolygon fill='%23444' points='180 900 270 750 90 750'/%3E%3Cpolygon fill='%23FFF' points='360 900 450 750 270 750'/%3E%3Cpolygon fill='%23AAA' points='540 900 630 750 450 750'/%3E%3Cpolygon fill='%23FFF' points='720 900 810 750 630 750'/%3E%3Cpolygon fill='%23222' points='900 900 990 750 810 750'/%3E%3Cpolygon fill='%23222' points='1080 300 990 450 1170 450'/%3E%3Cpolygon fill='%23FFF' points='1080 300 1170 150 990 150'/%3E%3Cpolygon points='1080 600 990 750 1170 750'/%3E%3Cpolygon fill='%23666' points='1080 600 1170 450 990 450'/%3E%3Cpolygon fill='%23DDD' points='1080 900 1170 750 990 750'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect x='0' y='0' fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect x='0' y='0' fill='url(%23b)' width='100%25' height='100%25'/%3E%3C/svg%3E");
	background-attachment: fixed;
	background-size: cover;
}

</style>
